import { render } from "./JoinRoom.vue?vue&type=template&id=3ad1d4a8"
import script from "./JoinRoom.vue?vue&type=script&lang=js"
export * from "./JoinRoom.vue?vue&type=script&lang=js"

import "./JoinRoom.vue?vue&type=style&index=0&id=3ad1d4a8&lang=css"
script.render = render

export default script